const filterListActionModalFilter = {
  filter: 'FILTROS',
  clearFilter: 'borrar todos los filtros'
};

export default filterListActionModalFilter;
